import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    children?: any;
    style?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
    headerText?: string;
    headerMargin?: {
        left?: number,
        right?: number,
        bottom?: number
    };
    isExpanded?: boolean;
    onClick?: () => void;
}

export class Expander extends React.Component<IProperties>
{
    private getContent()
    {
        if (this.props.isExpanded)
        {
            return (
                <div
                    style={this.props.contentStyle}
                    className="expander_content">
                    {this.props.children}
                </div>
            );
        }
        else
        {
            return null;
        }
    }

    render()
    {
        var headerStyle: any;
        if (this.props.headerMargin != null)
        {
            headerStyle = {
                marginLeft: this.props.headerMargin.left,
                marginRight: this.props.headerMargin.right,
                marginBottom: this.props.headerMargin.bottom
            };
        }

        return (
            <div
                className="expander"
                style={this.props.style}>
                <div
                    className="expander_header"
                    style={headerStyle}
                    onClick={this.props.onClick}>
                    <span className="expander_header_text">{this.props.headerText}</span>
                    <i className={`expander_header_icon mdi mdi-${this.props.isExpanded ? "chevron-down" : "chevron-up"}`}></i>
                </div>
                {this.getContent()}
            </div>
        );
    }
}